import { createGlobalStyle, } from 'styled-components';
import stylesheet from './stylesheet';
const styled = {
    createGlobalStyle,
};
export const GlobalStyle = styled.createGlobalStyle `
  ${stylesheet}
`;
export default GlobalStyle;
